import PropTypes from 'prop-types';
import { Checkbox } from '@bwoty-web/ui-kit';

import './destinationFilterContent.scss';

const buildCheckboxOptions = (destinationList, handleFilterChange, selectedDestinations, destinationPotentials) => {
  return destinationList.map((destination) => {
    let childrenCheckboxGroup;
    if (destination.children) {
      childrenCheckboxGroup = buildCheckboxOptions(destination.children, handleFilterChange, selectedDestinations, destinationPotentials);
    }
    return (
      <div key={destination.id}>
        <Checkbox
          className="po-list-destination-option"
          uniqueId={destination.name}
          onChange={event => handleFilterChange(event, destination)}
          checked={selectedDestinations.some(selectedDestination => selectedDestination.id === destination.id)}
          disabled={destinationPotentials[destination.id] === 0}
        >
          {`${destination.name} (${destinationPotentials[destination.id]})`}
        </Checkbox>
        {
          childrenCheckboxGroup && (
            <div className="po-list-destination-option-group">
              {childrenCheckboxGroup}
            </div>
          )
        }
      </div>
    );
  });
};

const DestinationFilterContent = (props) => {
  const {
    destinationTree,
    selectedDestinations,
    addDestinationFilter,
    removeDestinationFilter,
    destinationPotentials,
  } = props;

  const handleFilterChange = (event, destination) => {
    const { target } = event;
    if (target.checked) {
      addDestinationFilter(destination);
    } else {
      removeDestinationFilter(destination);
    }
  };

  const options = buildCheckboxOptions(destinationTree, handleFilterChange, selectedDestinations, destinationPotentials);

  return (
    <div className="po-list-destination-filter-content">
      {options}
    </div>
  );
};

DestinationFilterContent.propTypes = {
  destinationTree: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedDestinations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  addDestinationFilter: PropTypes.func.isRequired,
  removeDestinationFilter: PropTypes.func.isRequired,
  destinationPotentials: PropTypes.shape().isRequired,
};

export default DestinationFilterContent;
